import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/main/main').then((m) => m.Main),
    },
    {
        path: 'about',
        loadComponent: () => import('./pages/about/about').then(m => m.About)
    },
    {
        path: 'privacy',
        loadComponent: () => import('./pages/privacy/privacy').then(m => m.Privacy)
    },
    {
        path: 'terms',
        loadComponent: () => import('./pages/terms/terms').then(m => m.Terms)
    },
    {
        path: 'products/:slug',
        loadComponent: () => import('./pages/product-details/product-details.page').then(m => m.ProductDetailsPage)
    },
    {
        path: '**',
        loadComponent: () => import('./pages/not-found/not-found').then((m) => m.NotFound),
    }
];
